export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '考试名称',
    field: 'title',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '考试分类名称',
    field: 'examCategoryName'
  },
  {
    headerName: '考试类型',
    field: 'examType'
  },
  {
    headerName: '考试状态',
    field: 'status'
  },
  {
    headerName: '考试开始时间',
    field: 'startDate'
  },
  {
    headerName: '考试结束时间',
    field: 'endDate'
  },
  {
    headerName: '考试限制时长(分)',
    field: 'limitMinutes'
  },
  {
    headerName: '学员账号',
    field: 'account'
  },
  {
    headerName: '学员姓名',
    field: 'fullName'
  },
  // {
  //   headerName: '学员身份证',
  //   field: 'idCard',
  // },
  {
    headerName: '账号状态',
    field: 'accountState'
  },
  {
    headerName: '组织名称',
    field: 'orgName'
  },
  {
    headerName: '组织编码',
    field: 'orgCode'
  },
  {
    headerName: '组织类型',
    field: 'orgTypeName',
  },
  {
    headerName: '上级组织',
    field: 'leadName'
  },
  {
    headerName: '省份',
    field: 'province'
  },
  {
    headerName: '岗位名称',
    field: 'positionName'
  },
  {
    headerName: '任职状态',
    field: 'jobState'
  },
  {
    headerName: '参加考试时间',
    field: 'markingDate'
  },
  {
    headerName: '成绩得分',
    field: 'score'
  },
  {
    headerName: '考试通过状态',
    field: 'pass'
  },
  {
    headerName: '考试时长',
    field: 'duration'
  },
]
